import React from 'react'
import { formatCnpj } from '@bonitour/common-functions'

export const Cnpj = ({ value, ...other }) => <p {...other}>{formatCnpj(value)}</p>
